// src/js/optionDrawer.js
export function optionDrawer() {
  document
    .querySelectorAll(".redesign-option-drawer")
    .forEach((drawerSection) => {
      const tiles = drawerSection.querySelectorAll(".option-drawer-tile");

      let drawer = null;
      let overlay = null;

      let lastScrollY = 0;
      let resizeHandler = null;
      let escHandler = null;
      function closeDrawer() {
        if (drawer) {
          drawer.classList.remove("translate-x-0");
          drawer.classList.add("translate-x-full");
          if (overlay) overlay.classList.add("hidden");
          // Restore scroll and body style
          document.body.style.overflow = "";
          window.scrollTo(0, lastScrollY);
          // Remove resize event listener
          if (resizeHandler) {
            window.removeEventListener("resize", resizeHandler);
            resizeHandler = null;
          }
          // Remove Escape key event listener
          if (escHandler) {
            window.removeEventListener("keydown", escHandler);
            escHandler = null;
          }
          setTimeout(() => {
            if (drawer) drawer.remove();
            if (overlay) overlay.remove();
            drawer = null;
            overlay = null;
          }, 350);
        }
      }

      tiles.forEach((tile) => {
        tile.addEventListener("click", () => {
          // Remove any existing drawer and overlay
          if (drawer) drawer.remove();
          if (overlay) overlay.remove();

          // Store scroll position and prevent background scroll
          lastScrollY = window.scrollY;
          document.body.style.overflow = "hidden";

          // Create overlay
          overlay = document.createElement("div");
          overlay.className =
            "option-drawer-overlay fixed inset-0 bg-black bg-opacity-50 z-40 md:block";
          overlay.addEventListener("click", closeDrawer);
          document.body.appendChild(overlay);

          // Get content from hidden div by ID
          const drawerId = tile.getAttribute("data-drawer-id");
          const contentDiv = drawerSection.querySelector(`#${drawerId}`);
          const drawerHtml = contentDiv ? contentDiv.innerHTML : "";

          // Create drawer
          drawer = document.createElement("div");
          drawer.className =
            "option-drawer-content fixed top-0 right-0 h-full z-[101] shadow-xl transition-transform duration-500 ease-in-out translate-x-full overflow-y-auto";
          drawer.style.width = "100vw";
          drawer.innerHTML = drawerHtml;

          // Responsive width
          function setDrawerWidth() {
            if (!drawer) return;
            if (window.innerWidth >= 968) {
              drawer.style.width = "50vw";
            } else {
              drawer.style.width = "100vw";
            }
          }
          setDrawerWidth();
          resizeHandler = setDrawerWidth;
          window.addEventListener("resize", resizeHandler);

          // Add Escape key handler
          escHandler = function (e) {
            if (e.key === "Escape" || e.key === "Esc") {
              closeDrawer();
            }
          };
          window.addEventListener("keydown", escHandler);

          // Add close button with SVG
          const closeBtn = document.createElement("button");
          closeBtn.className = "option-drawer-close-btn";
          closeBtn.setAttribute("aria-label", "Close drawer");
          closeBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#4B5565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          closeBtn.addEventListener("click", closeDrawer);
          drawer.appendChild(closeBtn);

          // Make drawer focusable and shift focus for accessibility
          drawer.setAttribute("tabindex", "-1");
          document.body.appendChild(drawer);

          // Re-render reCAPTCHA widgets — innerHTML cloning doesn't preserve widget state
          drawer.querySelectorAll(".g-recaptcha").forEach((el) => {
            if (window.grecaptcha && el.dataset.sitekey) {
              el.innerHTML = "";
              window.grecaptcha.render(el, {
                sitekey: el.dataset.sitekey,
                theme: el.dataset.theme || "light",
                size: el.dataset.size || "normal",
              });
            }
          });

          setTimeout(() => {
            drawer.classList.remove("translate-x-full");
            drawer.classList.add("translate-x-0");
            drawer.focus();
          }, 10);
        });
      });
    });
}
